/*
 * Copyright (c) 2023.
 * @FileName: useFlatReq.ts
 * @Description: useFlatReq
 * @FilePath: globalSrc/hooks
 * @Project: wise_2023_member-center-sys_admin_frontend
 * @Author: lunazhou
 * @Date: 2023/5/27 15:22
 * @LastEditors: lunazhou
 * @LastEditTime: 2023/5/27 15:22
 */

/**
 * 扁平化请求响应
 * 用于处理请求，返回值为数组，第一个元素为错误，第二个元素为正确值
 * @param promise - 请求
 * @param [errExt] - 可选，错误扩展
 * @returns {Promise<[U, T]>} - 返回值为数组，第一个元素为错误，第二个元素为正确值
 */
export const useFlatRes = <T, U = Error>(promise: Promise<T>, errExt?: object) => {
  return promise
    .then<[null, T]>((data: T) => [null, data])
    .catch<[U, undefined]>((err: U) => {
      if (errExt) {
        const parsedErr = { ...err, ...errExt };
        return [parsedErr, undefined];
      }
      return [err, undefined];
    });
};

export default useFlatRes;
